<template>
  <div class="card-wrapper">
    <b-card v-for="item in callback" :key="item.id" class="card-text mb-4">
      <div class="d-md-flex justify-content-between align-items-start">
        <div class="d-block flex-grow-1 mb-md-0 mb-4 mr-md-3 mr-0">
          <div class="w-100 mb-2">
            <p class="text-muted mb-0">{{ $t('anyform.fullname') }}</p>
            <div>{{ item.name }}</div>
          </div>
          <div class="w-100 mb-2">
            <p class="text-muted mb-0">{{ $t('anyform.email') }}</p>
            <div>{{ item.email }}</div>
          </div>
          <div class="w-100">
            <p class="text-muted mb-0">{{ $t('anyform.message') }}</p>
            <div class="pr-5">{{ item.message }}</div>
          </div>
        </div>

        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i
            v-if="item.viewed === 'no'"
            class="glyph-icon simple-icon-pencil datalist-icon mr-2"
            title="Change status"
            @click="handleChangeStatus(item.id)"
          ></i>
          <i class="glyph-icon simple-icon-trash datalist-icon" @click="handleDelete(item.id)"></i>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    callback: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleChangeStatus(id) {
      this.$store.dispatch('callback/updateSingleCallback', { id, vm: this })
    },
    handleDelete(id) {
      this.$confirm({
        message: this.$t('confirm-dialog.question'),
        button: {
          no: this.$t('confirm-dialog.no'),
          yes: this.$t('confirm-dialog.yes')
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('callback/deleteSingleCallback', {
              id,
              vm: this
            })
          }
        }
      })
    }
  }
}
</script>
